<div class="popup-bg" (click)="close()">
</div>
<div class="popup-window">
  <div class="popup-title title">{{ title }} <a class="icon fr" href="javascript:void(0)" (click)="close()">x</a></div>
  <div class="deposit-row" style="margin-bottom: -5px;">
    <p class="title">{{ body }}</p>
  </div>
</div>
